<template>
  <div
    class="white-container"
    :key="$store.getters['resource/currentResource'].key">
    <TransactionView
      :fields="fields"
      :editing="true"
    />
  </div>
</template>

<script>
  import fields from './transactionsCreationFields.js';
  import TransactionView from './TransactionView'

  export default {
    name: 'TransactionEditing',
      middleware: 'auth',
    components: {
      TransactionView
    },
    computed: {
      id () {
        return this.$route.params.id || ''
      }
    },
    data () {
      return {
        fields: fields
      }
    },
    mounted () {
      if(!this.id){
        this.$router.push({path: '/transactions'})
      }
    }
  }
</script>